import { calcScore, scoreLabel } from '../lib/tax'

export default function QuarterlyScore({ transactions, receiptsUploaded, submissionsOnTime = 1 }) {
  const total = transactions.length
  const categorised = transactions.filter(t => t.category).length
  const expenseCount = transactions.filter(t => t.type === 'expense').length
  const catPct   = total > 0 ? (categorised / total) * 100 : 0
  const recPct   = expenseCount > 0 ? (receiptsUploaded / expenseCount) * 100 : 0
  const taxPot   = 60 // simulated — would be % of recommended amount set aside
  const score    = calcScore({ categorisedPct: catPct, receiptsUploaded: recPct, taxPotFunded: taxPot, submissionsOnTime: submissionsOnTime * 100 })
  const { label, cls } = scoreLabel(score)

  const r = 44, circ = 2 * Math.PI * r
  const dash = circ * (score / 100)

  return (
    <div style={{ display:'flex', alignItems:'center', gap:20 }}>
      <div className="score-ring">
        <svg width={106} height={106} viewBox="0 0 106 106">
          <circle cx={53} cy={53} r={r} fill="none" stroke="var(--navy-border)" strokeWidth={8} />
          <circle
            cx={53} cy={53} r={r} fill="none"
            stroke={score >= 80 ? 'var(--teal)' : score >= 50 ? 'var(--amber)' : 'var(--red)'}
            strokeWidth={8} strokeLinecap="round"
            strokeDasharray={`${dash} ${circ}`}
            style={{ transition:'stroke-dasharray .8s ease' }}
          />
        </svg>
        <div style={{ position:'absolute', textAlign:'center' }}>
          <div style={{ fontFamily:'var(--font-display)', fontSize:26, lineHeight:1 }}>{score}</div>
          <div style={{ fontSize:10, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'.06em' }}>/ 100</div>
        </div>
      </div>
      <div>
        <div style={{ fontSize:12, color:'var(--slate)', marginBottom:4 }}>Quarterly Score</div>
        <div className={`${cls}`} style={{ fontSize:20, fontWeight:700, marginBottom:10 }}>{label}</div>
        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
          {[
            { label:'Categorised', val: Math.round(catPct), color: catPct >= 80 ? 'var(--teal)' : 'var(--amber)' },
            { label:'Receipts',    val: Math.round(recPct), color: recPct >= 60 ? 'var(--teal)' : 'var(--amber)' },
            { label:'Tax pot',     val: taxPot,             color: taxPot >= 80  ? 'var(--teal)' : 'var(--amber)' },
          ].map(item => (
            <div key={item.label} style={{ display:'flex', alignItems:'center', gap:8 }}>
              <div style={{ width:80, fontSize:11, color:'var(--slate)' }}>{item.label}</div>
              <div style={{ flex:1, height:4, background:'var(--navy-border)', borderRadius:2, overflow:'hidden', width:100 }}>
                <div style={{ width:`${item.val}%`, height:'100%', background:item.color, borderRadius:2, transition:'width .6s' }} />
              </div>
              <div style={{ fontSize:11, color:item.color, width:32, textAlign:'right' }}>{item.val}%</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
